module.exports = __webpack_public_path__ + "static/media/marker-red.0a45e9d0.svg";